module.exports = __webpack_public_path__ + "static/media/044.e2e435b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/044.jpg
// module id = 389
// module chunks = 0